import styled from "@emotion/styled";
import { styled as muiStyled, TableRow as MuiTableRow } from "@mui/material";
import { EmptyView as _EmptyView } from "components/EmptyView";

export const TableRow = muiStyled(MuiTableRow)(
  ({ theme }) => `
  th {
      padding: 13px 0;
      color: #282828;
      font-weight: 700;
      border-bottom: 1px solid ${theme.palette.layout.line};
  }
`
);

export const EmptyView = styled(_EmptyView)(
  () => `
  min-height: calc(100vh - 262px);
`
);

export const SortColumnWrapper = styled.div`
  display: flex;
  gap: 4px;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;
